import { Component } from "@angular/core";
import { BarcodeService } from "app/shared/barcode.service";
import { DialogBaseComponent, DialogParams } from "app/shared/dialog-base.component";
import { DomainService } from "app/shared/domain.service";
import { PrintFns, SelectedPrinters } from "app/shared/print-fns";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
  selector: "app-notepad-printer-dialog",
  templateUrl: "./notepad-printer-dialog.component.html",
  standalone: false,
})
export class NotepadPrinterDialogComponent extends DialogBaseComponent<DialogParams> {
  barcodePrinter = "";
  clientPrinters: string[] = [];
  errorMessage = "Connecting to QZ printers...";
  showInstallHint = false;

  constructor(
    public config: DynamicDialogConfig<DialogParams>,
    public dialogRef: DynamicDialogRef,
    public domainService: DomainService,
    private barcodeService: BarcodeService
  ) {
    super(config, dialogRef, domainService);
    Object.assign(this.config, {
      header: "Barcode Printer",
      width: "min(90vw, 480px)",
      height: "auto",
    });
    void this.prepare();
  }

  async prepare() {
    const sp = PrintFns.getSelectedPrinters() || ({} as SelectedPrinters);
    this.barcodePrinter = sp.barcodePrinter ?? "";
    await this.detectPrinters();
    this.isPageReady = true;
  }

  async detectPrinters() {
    this.errorMessage = "Connecting to QZ printers...";
    this.showInstallHint = false;
    const started = await PrintFns.startQZ();
    if (!started) {
      this.errorMessage = "QZ Tray (print manager) could not start.";
      this.showInstallHint = true;
      this.clientPrinters = [];
      return;
    }
    const installed = await PrintFns.getInstalledPrinters();
    if (!installed || !installed.length) {
      this.errorMessage = "No printers found.";
      this.clientPrinters = [];
      return;
    }
    this.errorMessage = "";
    this.clientPrinters = installed.map((x: any) => (x?.name ? x.name : x));
  }

  save() {
    // Preserve sibling settings (invoice / label / format) used on desktop.
    const existing = PrintFns.getSelectedPrinters() || ({} as SelectedPrinters);
    const sp: SelectedPrinters = {
      ...existing,
      barcodePrinter: this.barcodePrinter,
    };
    PrintFns.saveSelectedPrinters(sp);
    this.toastr.success("Barcode printer saved");
  }

  testBarcode() {
    this.barcodeService.printTestBarcode();
  }

  close() {
    this.dialogRef.close(null);
  }
}
